export default "__VITE_ASSET__3ba43eac__"